import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GameService {
  // private apiUrl = 'http://localhost:9097/api/v1';
  private apiUrl = environment.baseHref+'api/v1/';
  // private localUrl = 'http://localhost:9097/api/v1';



  constructor(private http: HttpClient) {}

  signup(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}auth-service/user/signup`, payload);
  }

  login(payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}auth-service/user/user-signin`, payload);
  }

  getBanners(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}banner-service/banners`);
  }
  getGameById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}game-service/game/${id}`);
  }

  getGames(): Observable<any[]> {
    return this.http.get<any>(`${this.apiUrl}game-service/games`).pipe(
      map((res: any) => {
        if (Array.isArray(res)) return res;
        if (Array.isArray(res?.data)) return res.data;
        if (Array.isArray(res?.content)) return res.content;
        if (Array.isArray(res?.items)) return res.items;
        if (Array.isArray(res?.data?.content)) return res.data.content;
        return [];
      })
    );
  }

  // Fetch games with a limit (server supports query param: games?limit=). Fallback handled by callers if not.
  getGamesLimited(limit: number): Observable<any[]> {
    return this.http.get<any>(`${this.apiUrl}game-service/games`, { params: { limit: String(limit) } }).pipe(
      map((res: any) => {
        let arr: any[] = [];
        if (Array.isArray(res)) arr = res;
        else if (Array.isArray(res?.data)) arr = res.data;
        else if (Array.isArray(res?.content)) arr = res.content;
        else if (Array.isArray(res?.items)) arr = res.items;
        else if (Array.isArray(res?.data?.content)) arr = res.data.content;
        return arr.slice(0, limit);
      })
    );
  }

  incrementClickCount(gameId: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}game-service/${gameId}/click`, null);
  }

}
